export const DEFAULT_LIST_QUERY_KEY = 'all'
